import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  color: #5A6C87;
  line-height: 20px;
`;

const LoaderText = styled.span`
  font-weight: 400;
  color: #5A6C87;
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
`;

const InlineLoader = ({ text, size = "small" }) => {
  return (
    <LoaderContainer>
      <Spin 
        indicator={<LoadingOutlined style={{ fontSize: 16, color: '#0C53BB' }} spin />} 
        size={size}
      />
      {text && <LoaderText>{text}</LoaderText>}
    </LoaderContainer>
  );
};

InlineLoader.propTypes = {
  text: PropTypes.string,
  size: PropTypes.oneOf(['small', 'default', 'large'])
};

export default InlineLoader;
